export default __webpack_public_path__ + "static/media/tabs.ad48acfb.png";